import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Project from '@/components/Project'
import Scene from '@/components/Scene'
import Video from '@/components/Video'
import DataDownload from '@/components/DataDownload'
import Qa from '@/components/Qa'
import Playing from '@/components/Playing'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        title: 'METIS | Tip Biu BI'// 產品介紹
      }
    },
    {
      path: '/project',
      component: Project,
      meta: {
        title: 'METIS | Tip Biu BI'// 解決方案
      }
    },
    {
      path: '/scene',
      component: Scene,
      meta: {
        title: 'METIS | Tip Biu BI'//应用场景
      }
    },
    {
      path: '/video',
      component: Video,
      meta: {
        title: 'METIS | Tip Biu BI'// 影片教學
      }
    },
    {
      path: '/dataDownload',
      component: DataDownload,
      meta: {
        title: 'METIS | Tip Biu BI'// 知識資料
      }
    },
    {
      path: '/qa',
      component: Qa,
      meta: {
        title: 'METIS | Tip Biu BI'// FAQ
      }
    },
    {
      path: '/playing/:num',
      name: 'playing',
      component: Playing
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js